import { Injectable, Inject} from '@angular/core';
import { _Message } from '@utility/_Message';
import { WebStorageService, LOCAL_STORAGE } from 'angular-webstorage-service';

@Injectable({
  providedIn: 'root'
})
export class ServiceMensaje {

  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService){}

   //Mensajes Acción
   Toast = _Message.getToast();
   configuracion(parm) {
    var conf = [];
    conf = this.storage.get("CONFIGURACION");
    if (parm == "CO") {
      return conf[0]["up_confirmacion"];
    }
    if (parm == "IN") {
      return conf[0]["up_informativo"];
    }
  }
  showSuccess(message: string): void {
    if (this.configuracion("IN")) {
      this.Toast.fire({
        icon: 'success',
        title: message,
      });
   }
  }
  
  showError(message: string): void {
    if (this.configuracion("IN")) {
    this.Toast.fire({
      icon: 'error',
      title: message,
    });
  }
  }
}